<template>
  <div :class="classes">
    <pt-page-title title="创建委托单">
      <el-button type="primary" plain slot="on-right" :class="$style['created-button']" @click="goNew">手动填写委托单
      </el-button>
    </pt-page-title>
    <div v-if="errorInfo.length">
      <pt-sub-title title="异常提示"></pt-sub-title>
      <div style="margin:.3rem 0">
        <p v-for="(item,index) in errorInfo" :key="index" :class="$style.errorMsg">{{item}}</p>
      </div>
    </div>
    <pt-sub-title title="批量创建"></pt-sub-title>
    <pt-business-order-lot-form @errorMsg="errorMsg" style="margin:0 .2rem"></pt-business-order-lot-form>
  </div>
</template>

<script>
import ptBusinessOrderLotForm from 'cps/sell-order/pt-business-order-lot-new/pt-business-order-lot-form/withData'
// 组件class前缀
const prefixCls = 'pt-business-order-lot-new'

export default {
  name: 'pt-business-order-lot-new',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptBusinessOrderLotForm
  },
  data () {
    return {
      errorInfo: {}
    }
  },
  methods: {
    goNew () {
      this.$router.push('/trust-deed-form/false/0')
    },
    errorMsg (val) {
      this.errorInfo = this.changeMsg(val)
    },
    changeMsg (val) {
      let errorInfo = []
      if (val) {
        for (let i = 0; i < val.length; i++) {
          // let len = val[i] && val[i].errorMsg
          let len = val[i]
          console.log('len', val[i])
          errorInfo.push(len)
          // for (let n = 0; n < len.length; n++) {
          //   errorInfo.push(len[n])
          // }
        }
      }
      return errorInfo
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .created-button {
    margin-left: 40PX;
  }
  .errorMsg{
    color: rgb(245, 108, 108);
    margin: .2rem
  }
</style>
